import React from 'react';
import Image from 'src/components/ui/Image/Image';

type NoDataPlaceholderProps = {
  imgSrc?: string;
  size?: 'sm' | 'md';
  headline?: string;
  copy?: string;
  as?: keyof JSX.IntrinsicElements;
};

const NoDataPlaceholder: React.FC<NoDataPlaceholderProps> = ({
  imgSrc,
  headline,
  copy,
  as: Tag = 'h2',
  size = 'md',
}) => {
  const img = imgSrc ?? '/assets/illustrations/empty-box.png';
  const sizeClass = size === 'sm' ? 'w-[8rem]' : 'w-[10rem]] md:w-[23rem]';

  return (
    <div className="flex flex-col items-center gap-32">
      <div className={sizeClass}>
        <Image
          imageUrl={img}
          alt=""
          fallbackComponent={<div className="surface-skeleton-faded w-full h-full rounded-sm" />}
        />
      </div>
      <div className="flex flex-col items-center gap-8">
        {headline && <Tag className="typo-title-24">{headline}</Tag>}
        {copy && <p className="typo-text-16 text-faded">{copy}</p>}
      </div>
    </div>
  );
};

export default NoDataPlaceholder;
